const textBoxData = {
  others: [
    {
      mode: "textbox",
      text: "Right Click to Edit",
      bold: false,
      outlineColor: {
        red: 255,
        green: 255,
        blue: 255,
      },
      textColor: {
        red: 0,
        green: 0,
        blue: 0,
      },
      bgColor: {
        red: 255,
        green: 255,
        blue: 255,
      },
      fontSize: 20,
      alpha: 0.1,
      fontFamily: "Arial",
      x: 0,
      y: 1,
      z: 0,
      w: 3,
      h: 1.5,
      angle: 0,
    },
  ],
};

export default textBoxData;
